/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, {lazy} from 'react'
import {Redirect} from 'react-router-dom'
import AuthLayout from './layouts/Auth'
import ErrorLayout from './layouts/Error'
import DashboardLayout from './layouts/Dashboard'

export default [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/dashboard"/>
  },
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: lazy(() => import('src/views/Login'))
      },
      {
        component: () => <Redirect to="/errors/error-404"/>
      }
    ]
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-401',
        exact: true,
        component: lazy(() => import('src/views/Error401'))
      },
      {
        path: '/errors/error-404',
        exact: true,
        component: lazy(() => import('src/views/Error404'))
      },
      {
        path: '/errors/error-500',
        exact: true,
        component: lazy(() => import('src/views/Error500'))
      },
      {
        component: () => <Redirect to="/errors/error-404"/>
      }
    ]
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
      /* START_ROUTES */{
        path: '/dashboard',
        exact: true,
        component: lazy(() => import('src/views/OrdersLive'))
      },{
        path: '/dashboard/:id',
        exact: true,
        component: lazy(() => import('src/views/Dashboard/DashboardDetails'))
      },{
        path: '/clients',
        exact: true,
        component: lazy(() => import('src/views/Clients'))
      },{
        path: '/clients/:id',
        exact: true,
        component: lazy(() => import('src/views/Clients/ClientsDetails'))
      },{
        path: '/orders/live',
        exact: true,
        component: lazy(() => import('src/views/OrdersLive'))
      },{
        path: '/orders/new',
        exact: true,
        component: lazy(() => import('src/views/OrdersNew'))
      },{
        path: '/orders/new/:id',
        exact: true,
        component: lazy(() => import('src/views/OrdersNew/OrdersNewDetails'))
      },{
        path: '/orders/processing',
        exact: true,
        component: lazy(() => import('src/views/OrdersProcessing'))
      },{
        path: '/orders/processing/:id',
        exact: true,
        component: lazy(() => import('src/views/OrdersProcessing/OrdersProcessingDetails'))
      },{
        path: '/orders/all',
        exact: true,
        component: lazy(() => import('src/views/OrdersAll'))
      },{
        path: '/orders/all/:id',
        exact: true,
        component: lazy(() => import('src/views/OrdersAll/OrdersAllDetails'))
      },{
        path: '/orders/delivery',
        exact: true,
        component: lazy(() => import('src/views/OrdersDelivery'))
      },{
        path: '/orders/delivery/:id',
        exact: true,
        component: lazy(() => import('src/views/OrdersDelivery/OrdersDeliveryDetails'))
      },{
        path: '/branches',
        exact: true,
        component: lazy(() => import('src/views/Branches'))
      },{
        path: '/branches/:id',
        exact: true,
        component: lazy(() => import('src/views/Branches/BranchesDetails'))
      },{
        path: '/drivers',
        exact: true,
        component: lazy(() => import('src/views/Drivers'))
      },{
        path: '/drivers/:id',
        exact: true,
        component: lazy(() => import('src/views/Drivers/DriversDetails'))
      },{
        path: '/offers',
        exact: true,
        component: lazy(() => import('src/views/Offers'))
      },{
        path: '/offers/:id',
        exact: true,
        component: lazy(() => import('src/views/Offers/OffersDetails'))
      },{
        path: '/ratings',
        exact: true,
        component: lazy(() => import('src/views/Ratings'))
      },{
        path: '/ratings/:id',
        exact: true,
        component: lazy(() => import('src/views/Ratings/RatingsDetails'))
      },{
        path: '/reservation',
        exact: true,
        component: lazy(() => import('src/views/Reservation'))
      },{
        path: '/reservation/:id',
        exact: true,
        component: lazy(() => import('src/views/Reservation/ReservationDetails'))
      },{
        path: '/settings/app',
        exact: true,
        component: lazy(() => import('src/views/SettingsApp'))
      },{
        path: '/settings/app/:id',
        exact: true,
        component: lazy(() => import('src/views/SettingsApp/SettingsAppDetails'))
      },{
        path: '/settings/notifications',
        exact: true,
        component: lazy(() => import('src/views/SettingsNotifications'))
      },{
        path: '/settings/notifications/:id',
        exact: true,
        component: lazy(() => import('src/views/SettingsNotifications/SettingsNotificationsDetails'))
      },{
        path: '/user/management/roles',
        exact: true,
        component: lazy(() => import('src/views/UserManagementRoles'))
      },{
        path: '/user/management/roles/:id',
        exact: true,
        component: lazy(() => import('src/views/UserManagementRoles/UserManagementRolesDetails'))
      },{
        path: '/user/management/users',
        exact: true,
        component: lazy(() => import('src/views/UserManagementUsers'))
      },{
        path: '/user/management/users/:id',
        exact: true,
        component: lazy(() => import('src/views/UserManagementUsers/UserManagementUsersDetails'))
      },
	/* END_ROUTES */









      {
        component: () => <Redirect to="/errors/error-404"/>
      }
    ]
  }
]
